<template>
 <v-card>
          <v-card-title> <h3 class="headline mb-0">Recycle Bin</h3>
          <v-btn text icon color="grey lighten-1" @click="refreshDeletedSystems"><v-icon>fas fa-sync</v-icon></v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="searchDeleted"
              append-icon="fal fa-search"
              placeholder="Search"
              single-line
              hide-details
              clearable
            ></v-text-field>
          </v-card-title>
    <v-data-table
      :headers="headers"
      :items="deletedSystems"
      :search="searchDeleted"
      :options.sync="pagination"
      v-model="selected"
      show-select
      :loading="loading"
      class="elevation-1"
    >
        <template v-slot:item.name="{item}">
            <td>
                <router-link :to="{ name: 'sysconfig', params: { id: item.id }}">
                            {{ item.name }}
                </router-link> &nbsp;
                <v-icon small v-if="item.isCloudSystem">fal fa-cloud</v-icon>
            </td>
        </template>
        <template v-slot:item.host="{item}">
            <td>
                <a :href="formatHostLink(item.host, item.configs)" target="_blank">{{ item.host }}</a>
            </td>
        </template>
        <template v-slot:item.createdDate="{item}">
            <td>{{ formatDate(item.createdDate) }}</td>
        </template>
        <template v-slot:item.updatedDate="{item}">
            <td>{{ formatDateTime(item.updatedDate) }}</td>
        </template>
        <template v-slot:item.actions="{item}">
            <td class="actions">
                 <v-tooltip bottom>
                  <template v-slot:activator="{on}">
                    <v-btn text icon @click="undelete(item.id)" v-on="on"
                    style="height: 0px; width: 0px; padding-right:2px;">
                    <v-icon color="grey lighten-1" style="font-size: 18px;">fas fa-trash-restore</v-icon>
                    </v-btn>
                  </template>
                  <span>Restore</span>
                </v-tooltip>
            </td>
        </template>
    </v-data-table>
            <v-card-actions>
                <v-btn @click="undeleteSelected" :disabled="!selected.length">Restore Selected</v-btn>
          </v-card-actions>
        </v-card>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import _ from 'lodash'
export default {
    data() {
        return {
            selected: [],
            searchDeleted: '',
            loading: false,
            deletedSystems: [],
            headers: [
                {text: 'Id', align: 'left', sortable: true, value: 'id'},
                {text: 'Type', align: 'left', sortable: true, value: 'type.name'},
                {text: 'Name', align: 'left', sortable: true, value: 'name'},
                {text: 'Description', align: 'left', sortable: true, value: 'description'},
                {text: 'Host', align: 'left', sortable: true, value: 'host'},
                {text: 'Created', align: 'left', sortable: true, value: 'createdDate'},
                {text: 'Updated', align: 'left', sortable: true, value: 'updatedDate'},
                {text: 'Actions', align: 'left', sortable: false, value: 'actions'}
            ],
            pagination : {'sortBy': ['updatedDate'], 'sortDesc': [true]}

        }
    },
    async created() {
        this.loading = true
        this.deletedSystems = await this.$store.dispatch('systems/getDeletedSystems')
        this.loading = false
    },
    methods: {
        formatDateTime(val) {
            return moment(val).format('MM/DD/YYYY, h:mm:ss a')
        },
        formatDate(val) {
            return moment(val).format('MM/DD/YYYY')
        },
        formatHostLink(host, configs) {
            let protocol = !configs ? "" : configs["Protocol"]
            protocol = protocol ? protocol.toLowerCase() : "https"
            return !host ? "" : protocol + "://" + host
        },
        async undelete(id) {
            await this.$store.dispatch('systems/unDeleteSystem', id)
            this.$emit('systemUnDeleted', id)
            await this.refreshDeletedSystems()
        },
        async refreshDeletedSystems() {
            this.loading = true
            this.deletedSystems = await this.$store.dispatch('systems/getDeletedSystems')
            this.loading = false
        },
        async undeleteSelected() {
            await this.$store.dispatch('systems/unDeleteMultipleSystems', this.selected)
            this.$emit('systemsUnDeleted', this.selected)
            this.selected = []
            await this.refreshDeletedSystems()
        }
    }
}
</script>
